module.exports = __webpack_public_path__ + "img/icons-fill-vehicles-saphhire.bd0cf948.svg";